// src/Footer.jsx
import { useContext } from 'react';
import ScriptContext from './ScriptContext';
import useScript from './useScript';

function Footer() {
  const { projects, activeFilter } = useContext(ScriptContext);

  if (!projects) {
    return null;
  }

  // Build visible project list
  const visibleProjects = projects.filter(function (p) {
    if (!p || !p.categories) return false;
    return (
      activeFilter === 'category-all' ||
      p.categories.split(' ').includes(activeFilter)
    );
  });

  // Build popup initialization script
  let text = '';
  for (let el of visibleProjects) {
    text += "$('#" + el.label + "').magnificPopup(" + JSON.stringify(el.config) + ");\n";
  }

  // ✅ Execute initialization script (same behavior as before)
  useScript(text);

  return null;
}

export default Footer;
